import { tw } from 'twind';
import type { FC, CSSProperties } from 'react';
import React from 'react';
import tailwind from '../../twind.config';

interface CheckoutLoadingProps {
  theme?: string | null;
  brandName?: string | null;
}

const CheckoutLoading: FC<CheckoutLoadingProps> = ({ brandName = '', theme }) => {
  const color: string = theme ? tailwind.theme?.extend?.colors[theme]['DEFAULT'] : 'yellow';
  const style: CSSProperties = { '--my-color': color };

  return (
    <div className={tw`fixed inset-0 bg-[#fff] z-10 flex flex-col justify-center items-center`}>
      <div className="checkout-loader JS_on" style={style}>
        <span className="binary"></span>
        <span className="binary"></span>
      </div>
      <span className={tw`relative top-[-10px] px-[10px] max-w-[400px] text-[14px] text-center font-inter font-thin`}>
        I’m grabbing your items from the shelf and sending you to
        {brandName !== '' ? <span className={tw`font-extrabold`}>&nbsp;{brandName}’s&nbsp;</span> : null}
        checkout.
      </span>
    </div>
  );
};

export default CheckoutLoading;
